import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import Script from "next/script";
import AgentLoginModal from "../AgentLoginModal/AgentLoginModal.esm.js";
import B2BLayout from "../B2BLayout/B2BLayout.esm.js";
import ZillowPreferredLogo from "./assets/zillow-preferred.svg.esm.js";
import { HEADER_CTAS, FOOTER_COLUMNS, LAYOUT_MENU_ITEMS } from "./constants/layout.esm.js";
const ZillowPreferredLayout = ({
  children,
  submenu,
  header,
  router,
  environment,
  knotchAccountId
}) => {
  const img = {
    src: ZillowPreferredLogo,
    alt: "Zillow Preferred",
    width: 215,
    height: 25,
    blurHeight: 0,
    blurWidth: 0,
    link: "/preferred/"
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    !!knotchAccountId && /* @__PURE__ */ jsx(Script, { src: `https://www.knotch-cdn.com/ktag/latest/ktag.min.js?accountId=${knotchAccountId}` }),
    /* @__PURE__ */ jsx(B2BLayout, { router, env: environment, signInRedirectParam: "redirect", logo: img, menu: LAYOUT_MENU_ITEMS, submenu, transparent: header == null ? void 0 : header.transparent, disabled: header == null ? void 0 : header.disabled, footerColumns: FOOTER_COLUMNS, secondaryCTALabel: HEADER_CTAS.secondary.label, secondaryCTAModal: /* @__PURE__ */ jsx(AgentLoginModal, { title: HEADER_CTAS.secondary.label }), sticky: true, children })
  ] });
};
export {
  ZillowPreferredLayout as default
};
